export default __webpack_public_path__ + "46957bf0a71db58833138e00cb6f4eb8.woff2";